import React, { useEffect, useState } from "react";
import { Table, Typography, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ReDirecticon } from "../../../Assets/images/icon/ReDirectIcon.svg";
import apiClient from "../../utilities/apiService";
import { ReactComponent as VerifiedIcon } from "../../../Assets/images/icon/verifiedIcon.svg";

const { Title } = Typography;

const ReportsTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  const fetchReports = async (page = 0, size = 10) => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        `${process.env.REACT_APP_BACKEND_URL}/admin/reportedContent/list?page=${page}&size=${size}`
      );

      const reports = response.data?.data?.reports || [];
      const paginationInfo = response.data?.data?.pagination || {};

      const formattedData = reports?.map((report, index) => ({
        key: report?.id || {index},
        reporter: `${report?.reporterUser?.userName || "Unknown"}`,
        reporterId: report?.reporterId,
        reporterVerified: report?.reporterUser?.verified,
        reportedUser: `${report?.reportedUser?.userName || "Unknown"}`,
        reportedUserVerified: report?.reportedUser?.verified,
        reportedUserId: report?.reportedUserId,
        type: report?.contentType || "POST",
        reason: report?.reason || "---",
        contentId: report?.contentId || "0",
      }));

      setData(formattedData);

      setPagination({
        current: paginationInfo.pageNumber + 1,
        pageSize: paginationInfo.pageSize,
        total: paginationInfo.totalElements,
      });
    } catch (error) {
      console.error("API Error:", error);
      console.error("Error Response:", error?.response);
      message.error(
        error?.response?.data?.message || "Failed to load reports."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleTableChange = (pagination) => {
    fetchReports(pagination.current - 1, pagination.pageSize);
  };

  const handleIconClick = (record) => {
    if (record.type === "RECREATION") {
      navigate(`/posts/${record.contentId}`);
    } else if (record.type === "POST") {
      navigate(`/recipe/${record.contentId}`);
    } else if (record.type === "User Profile") {
      navigate(`/userdetails/${record.reportedUser}`);
    }
  };
  const formatText = (text) => {
    return text
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const columns = [
    {
      title: "Reporter",
      dataIndex: "reporter",
      key: "reporter",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "8px",
          }}
        >
          <span>{text}</span>
          {record?.reporterVerified && (
            <VerifiedIcon style={{ width: "30px", height: "30px" }} />
          )}
          <span>({record?.reporterId})</span>
        </div>
      ),
    },
    {
      title: "Reported User",
      dataIndex: "reportedUser",
      key: "reportedUser",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "8px",
          }}
        >
          <span>{text}</span>
          {record?.reportedUserVerified && (
            <VerifiedIcon style={{ width: "30px", height: "30px" }} />
          )}
          <span>{record?.reportedUserId}</span>
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (text) => <span>{formatText(text)}</span>,
    },
    {
      title: "View",
      key: "view",
      align: "center",
      render: (record) => (
        <div
          onClick={() =>
            (record.type === "POST" ||
              record.type === "RECREATION" ||
              record.type === "User Profile") &&
            handleIconClick(record)
          }
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor:
              record.type === "POST" ||
              record.type === "RECREATION" ||
              record.type === "User Profile"
                ? "pointer"
                : "not-allowed",
            opacity:
              record.type === "POST" ||
              record.type === "RECREATION" ||
              record.type === "User Profile"
                ? 1
                : 0.5,
          }}
        >
          <ReDirecticon
            style={{
              width: "24px",
              height: "24px",
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div
      className="flex-grow-content"
      style={{
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "80%",
      }}
    >
      <Title level={4} style={{ textAlign: "left", width: "100%" }}>
        Reports
      </Title>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          bordered={false}
          style={{
            borderRadius: "8px",
            width: "100%",
            border: "1px solid #E1E1E1",
            cursor: "pointer",
          }}
          onRow={(record) => ({
            onClick: () => {
              if (
                record.type === "POST" ||
                record.type === "RECREATION" ||
                record.type === "User Profile"
              ) {
                handleIconClick(record);
              }
            },
          })}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showTotal: (total) => `Total ${total} items`,
          }}
          onChange={handleTableChange}
        />
      )}
    </div>
  );
};

export default ReportsTable;
